import {
    Keys, Navigation, StringUtil, UrlUtil
} from "@mcleod/core";
import {
    DataSourceExecutionEvent,
    DataSourceMode
} from "@mcleod/components";
import { AutogenLayoutProspectList } from "./autogen/AutogenLayoutProspectList";
import { LocationToProspect } from "./LocationToProspect";
import { ProspectToLocation } from "./ProspectToLocation";

export class ProspectList extends AutogenLayoutProspectList {
    override onLoad() {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search)
        if (urlProp != null && urlProp.ids != null) {
            this.mainDataSource.search({ ids: urlProp.ids });
        }
    }

    buttonProspectToLocationOnClick() {
        ProspectToLocation.showAsSlideout(this.mainDataSource.data, this.buttonProspectToLocation);
    }

    sourceProspectAfterExecution(event: DataSourceExecutionEvent) {
        this.buttonProspectToLocation.enabled = this.mainDataSource.rowCount > 0;
    }
}